<template>
  <v-container fluid>
    <div class="d-flex align-center mb-2">
      <div class="ml-1 font-weight-medium">
        [107] บันทึกเวลา - มาสาย/กลับก่อน
      </div>
      <v-spacer></v-spacer>
      <div class="d-flex align-center">
        <v-btn-toggle
          v-model="reportLanguage"
          borderless
          mandatory
          color="primary"
          dense
          class="mr-2"
        >
          <v-btn value="th">TH</v-btn>
          <v-btn value="en">EN</v-btn>
        </v-btn-toggle>
        <v-btn
          :disabled="
            (uiCtrl && !uiCtrl.isEnable('btn:::report:report_107:pdf:get')) ||
            (uiCtrl && !uiCtrl.isEnable('btn:::report:report_107:get'))
          "
          depressed
          class="mr-3"
          @click="handleDownloadFilePdf"
        >
          <v-icon left color="error">mdi-file-pdf-box</v-icon>
          Pdf
        </v-btn>
        <v-btn
          :disabled="
            (uiCtrl && !uiCtrl.isEnable('btn:::report:report_107:excel:get')) ||
            (uiCtrl && !uiCtrl.isEnable('btn:::report:report_107:get'))
          "
          depressed
          @click="handleDownloadFileExcel"
        >
          <v-icon left color="success">mdi-file-excel-box</v-icon>
          Excel
        </v-btn>
      </div>
    </div>
    <v-card outlined min-width="100%" class="px-3 mb-1">
      <div class="d-flex align-end flex-wrap py-2">
        <div class="mr-2">
          <div style="color: #555; font-size: 12px; margin-left: 5px">
            วันที่เริ่มต้น
          </div>
          <date-picker
            v-model="dateStart"
            :class="{ 'date-picker-required': isDateStartInvalidOnSearch }"
            type="date"
            format="DD/MM/YYYY"
            :clearable="true"
            :disabled-date="disabledAfterDateEnd"
          ></date-picker>
        </div>
        <div class="mr-2">
          <div style="color: #555; font-size: 12px; margin-left: 5px">
            วันที่สิ้นสุด
          </div>
          <date-picker
            v-model="dateEnd"
            :class="{ 'date-picker-required': isDateEndInvalidOnSearch }"
            type="date"
            format="DD/MM/YYYY"
            :clearable="true"
            :disabled-date="disabledBeforeDateStart"
          ></date-picker>
        </div>
        <div class="mr-2" style="margin-bottom: 1px">
          <label class="caption grey--text text--darken-2 ml-1">
            สถานะเข้าทำงาน
          </label>
          <v-select
            v-model="filterStatusWork"
            class="fix-google-chrome"
            :items="[
              { text: 'ทั้งหมด', value: null },
              { text: 'ปกติ', value: 'normal' },
              { text: 'เข้าสาย', value: 'is_late' },
              { text: 'ออกก่อน', value: 'is_early' },
              { text: 'เข้าสายและออกก่อน', value: 'is_late_and_early' },
            ]"
            item-text="text"
            item-value="value"
            hide-details
            outlined
            dense
          ></v-select>
        </div>
        <div class="mr-2">
          <div style="color: #555; font-size: 12px; margin-left: 5px">
            หน่วยงาน
          </div>
          <v-card
            min-height="42"
            min-width="240"
            class="pa-2"
            outlined
            @click="dialogOrganization = true"
          >
            <span v-if="selectedOrganizations.length === 1">
              <v-chip
                small
                v-for="organization in selectedOrganizations.slice(0, 1)"
                :key="organization.organization_uuid"
              >
                {{ organization.title_th }}
              </v-chip>
            </span>
            <span
              v-else-if="selectedOrganizations.length > 1"
              style="color: #555; font-size: 13px"
            >
              {{ selectedOrganizations.length }} หน่วยงาน
            </span>
          </v-card>
        </div>
        <div class="mr-2">
          <div style="color: #555; font-size: 12px; margin-left: 5px">
            พนักงาน
          </div>
          <v-card
            min-height="42"
            min-width="240"
            class="pa-2"
            :class="{ 'required-border': isEmployeeInvalidOnSearch }"
            outlined
            @click="dialogEmployee = true"
          >
            <span v-if="employeesSelected.length === 1">
              <v-chip
                small
                v-for="employee in employeesSelected.slice(0, 1)"
                :key="employee.employee_uuid"
              >
                {{ employee.firstname_th }} {{ employee.lastname_th }}
              </v-chip>
            </span>
            <span
              v-else-if="employeesSelected.length > 1"
              style="color: #555; font-size: 13px"
            >
              พนักงาน {{ employeesSelected.length }} คน
            </span>
          </v-card>
        </div>
        <div class="mr-4" style="margin-bottom: 1px">
          <label class="caption grey--text text--darken-2 ml-1">
            รูปแบบการออกรายงาน
          </label>
          <v-select
            v-model="filterReportType"
            class="fix-google-chrome"
            style="width: 220px"
            :items="[
              {
                text: 'ขึ้นหน้าใหม่ เมื่อเปลี่ยนหน่วยงาน',
                value: 'organization',
              },
              { text: 'ขึ้นหน้าใหม่ เมื่อเปลี่ยนพนักงาน', value: 'employee' },
              { text: 'ข้อมูลเรียงต่อกัน', value: null },
            ]"
            item-text="text"
            item-value="value"
            hide-details
            outlined
            dense
          >
            <template v-slot:selection="{ item }">
              <div style="font-size: 13px">
                {{ item.text }}
              </div>
            </template>
            <template v-slot:item="{ item }">
              <v-list-item-content>
                <v-list-item-title
                  class="py-1"
                  v-text="item.text"
                ></v-list-item-title>
              </v-list-item-content>
            </template>
          </v-select>
        </div>
        <!-- <div class="mr-4">
          <div style="color: #555; font-size: 12px; margin-left: 5px">
            Device
          </div>
          <v-card
            min-height="42"
            min-width="240"
            class="pa-2"
            outlined
            @click="dialogHardware = true"
          >
            <span v-if="isTransactionMobile" class="mr-1">
              <v-chip small>Mobile Device</v-chip>
            </span>
            <span v-if="hardwaresSelected.length === 1">
              <v-chip
                small
                v-for="hardware in hardwaresSelected.slice(0, 1)"
                :key="hardware.hardware_uuid"
              >
                {{ hardware.title_th }}
              </v-chip>
            </span>
            <span
              v-else-if="hardwaresSelected.length > 1"
              style="color: #555; font-size: 13px"
            >
              Device {{ hardwaresSelected.length }} เครื่อง
            </span>
          </v-card>
        </div> -->
        <div class="mt-2 mb-1">
          <v-btn
            :disabled="
              loading ||
              employeesSelected.length === 0 ||
              (uiCtrl && !uiCtrl.isEnable('btn:::report:report_107:get'))
            "
            depressed
            color="primary"
            @click="handleGetDataFromApi"
            >ตกลง</v-btn
          >
          <v-btn
            outlined
            color="primary"
            class="ml-2"
            @click="dialogWorkTimeReprocess = true"
            >คำนวณใหม่</v-btn
          >
        </div>
      </div>
    </v-card>

    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      :headers="headers"
      :items="reports"
      :options.sync="options"
      :server-items-length="totalReport"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50, 100],
        itemsPerPageText: 'Row per page:',
      }"
      must-sort
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-if="!items.length">
            <td style="text-align: center" colspan="10">No data available</td>
          </tr>
          <template v-else>
            <tr
              v-for="(item, index) in groupedReports"
              :key="item.employee_uuid + item.transaction_date"
              :style="{
                backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff',
              }"
            >
              <td
                style="
                  width: 140px;
                  vertical-align: top;
                  padding: 12px 16px;
                  text-wrap: nowrap;
                "
              >
                {{ item.showEmployeeCode ? item.employee_code : '' }}
              </td>
              <td
                style="
                  width: 240px;
                  vertical-align: top;
                  padding: 12px 16px;
                  text-wrap: nowrap;
                "
              >
                {{
                  item.showEmployeeName
                    ? reportLanguage === 'th'
                      ? `${item.firstname_th || ''} ${item.lastname_th || ''}`
                      : `${item.firstname_en || ''} ${item.lastname_en || ''}`
                    : ''
                }}
              </td>
              <td
                style="
                  width: 80px;
                  text-align: center;
                  vertical-align: top;
                  padding: 12px 16px;
                "
              >
                {{
                  reportLanguage === 'th'
                    ? item.date_title_short_th
                    : item.date_title_short_en
                }}
              </td>
              <td
                style="
                  width: 120px;
                  text-align: center;
                  vertical-align: top;
                  padding: 12px 16px;
                "
              >
                {{ item.transaction_date | dateFormat }}
              </td>
              <td
                style="
                  width: 135px;
                  text-align: center;
                  vertical-align: top;
                  padding: 12px 16px;
                  white-space: nowrap;
                "
              >
                {{ `${item.shift.time_in} - ${item.shift.time_out}` }}
              </td>
              <td
                style="
                  width: 120px;
                  text-align: center;
                  vertical-align: top;
                  padding: 12px 16px;
                "
              >
                {{ item.time_in }}
              </td>
              <td
                style="
                  width: 120px;
                  text-align: center;
                  vertical-align: top;
                  padding: 12px 16px;
                "
              >
                <v-chip v-if="item.late" outlined color="red">
                  {{ item.late }}
                </v-chip>
              </td>
              <td style="width: 120px; vertical-align: top; padding: 12px 16px">
                <v-chip v-if="item.hardware_in" label small>
                  {{ item.hardware_in }}
                </v-chip>
              </td>
              <td
                style="
                  width: 120px;
                  text-align: center;
                  vertical-align: top;
                  padding: 12px 16px;
                "
              >
                {{ item.time_out }}
              </td>
              <td
                style="
                  width: 120px;
                  text-align: center;
                  vertical-align: top;
                  padding: 12px 16px;
                "
              >
                <v-chip v-if="item.early" outlined color="red">
                  {{ item.early }}
                </v-chip>
              </td>
              <td style="width: 120px; vertical-align: top; padding: 12px 16px">
                <v-chip v-if="item.hardware_out" label small>
                  {{ item.hardware_out }}
                </v-chip>
              </td>
              <td
                style="
                  width: 160px;
                  vertical-align: top;
                  padding: 12px 16px;
                  white-space: nowrap;
                "
              >
                {{
                  reportLanguage === 'th'
                    ? item.holiday_type.title_th
                    : item.holiday_type.title_en
                }}
              </td>
              <td
                style="
                  width: 160px;
                  vertical-align: top;
                  padding: 12px 16px;
                  white-space: nowrap;
                "
              >
                {{ reportLanguage === 'th' ? item.remark_th : item.remark_en }}
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-data-table>

    <v-dialog v-model="dialogProgress" persistent width="320">
      <div class="pa-4 white">
        <v-progress-linear :value="progressValue" height="25">
          <strong>{{ Math.ceil(progressValue) }}%</strong>
        </v-progress-linear>
      </div>
    </v-dialog>

    <v-dialog v-model="dialogOrganization" persistent scrollable width="480px">
      <v-card>
        <v-card-title class="pt-0 pb-4">
          <v-checkbox
            :disabled="loadingOrganization"
            label="เลือกทั้งหมด"
            hide-details
            :input-value="
              statusSelectedAllOrganization &&
              statusSelectedAllEmployee === 'all'
            "
            @change="handleSelectedAllOrganization($event)"
          ></v-checkbox>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0" style="height: 320px">
          <div class="px-6 py-2">
            <v-text-field
              v-model="searchOrganization"
              :loading="loadingOrganization"
              outlined
              placeholder="ค้นหา"
              prepend-inner-icon="mdi-magnify"
              dense
              hide-details
              clearable
              @input="handleSearchOrganization"
            ></v-text-field>
          </div>
          <ul style="list-style: none">
            <organization-tree-item
              v-for="organization in organizations"
              :key="organization.organization_uuid"
              :organization="organization"
              :loadingOrganization="loadingOrganization"
              :handleSelectedOrganization="handleSelectedOrganization"
            />
          </ul>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="loadingOrganization"
            color="primary"
            text
            @click="handleDialogOrganization"
          >
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEmployee" persistent width="480px">
      <v-card>
        <div class="px-6 py-4 d-flex">
          <v-text-field
            v-model="searchEmployee"
            outlined
            placeholder="ค้นหา"
            prepend-inner-icon="mdi-magnify"
            dense
            hide-details
            clearable
          ></v-text-field>
          <v-select
            v-model="filterIsActive"
            class="ml-4 white"
            :items="[
              { id: 1, text: 'Active', value: true },
              { id: 2, text: 'Not Active', value: false },
              { id: 3, text: 'All Status', value: null },
            ]"
            item-text="text"
            item-value="value"
            label="สถานะพนักงาน"
            prepend-inner-icon="mdi-filter-variant"
            dense
            outlined
            hide-details
            @change="handleFilterIsActive"
            style="max-width: 180px"
          ></v-select>
        </div>
        <div class="px-6">
          <v-checkbox
            class="mt-0 mb-2"
            label="เลือกทั้งหมด"
            hide-details
            :input-value="statusSelectedAllEmployee === 'all'"
            :indeterminate="statusSelectedAllEmployee === 'indeterminate'"
            @change="handleSelectedAllEmployee($event)"
          ></v-checkbox>
          <v-divider></v-divider>
        </div>

        <v-card-text class="pa-0">
          <RecycleScroller
            style="height: 320px; margin-top: 10px"
            :items="filterEmployees"
            :item-size="46"
            key-field="employee_uuid"
            v-slot="{ item }"
          >
            <div class="px-6 d-flex align-center justify-space-between">
              <v-checkbox
                class="ma-0"
                :label="`${item.employee_code} - ${item.firstname_th} ${item.lastname_th}`"
                :input-value="item.checked"
                @change="handleSelectedEmployee($event, item)"
                hide-details
              ></v-checkbox>
              <!-- <v-chip
                dark
                small
                outlined
                :color="item.is_active ? 'green lighten-1' : 'grey'"
              >
                {{ item.is_active ? 'Active' : 'Not Active' }}
              </v-chip> -->
            </div>
          </RecycleScroller>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="handleDialogEmployee">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogHardware" persistent width="480px">
      <v-card>
        <v-card-title class="pt-0 pb-4">
          <v-checkbox
            label="เลือกทั้งหมด"
            hide-details
            :input-value="statusSelectedAllHardware === 'all'"
            :indeterminate="statusSelectedAllHardware === 'indeterminate'"
            @change="handleSelectedAllHardware($event)"
          ></v-checkbox>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-0">
          <div class="px-6 py-2">
            <v-text-field
              v-model="searchHardware"
              outlined
              placeholder="ค้นหา"
              prepend-inner-icon="mdi-magnify"
              dense
              hide-details
              clearable
            ></v-text-field>
          </div>
          <div>
            <v-checkbox
              v-model="isTransactionMobile"
              class="mt-2 px-6 mb-4"
              label="Mobile Device"
              hide-details
            ></v-checkbox>
          </div>
          <v-divider></v-divider>
          <RecycleScroller
            style="height: 320px"
            :items="filterHardwares"
            :item-size="46"
            key-field="hardware_uuid"
            v-slot="{ item }"
          >
            <div>
              <v-checkbox
                class="px-6 py-0 mt-3 mx-0"
                :label="`${item.hardware_code} - ${item.title_th}`"
                :input-value="item.checked"
                @change="handleSelectedHardware($event, item)"
                hide-details
              ></v-checkbox>
            </div>
          </RecycleScroller>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="handleDialogHardware">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogWorkTimeReprocess" width="485">
      <v-card style="position: relative">
        <v-card-title class="text-h5 d-flex justify-space-between">
          <span>คำนวณบันทึกเวลา - มาสาย/กลับก่อนใหม่</span>
          <v-btn
            icon
            style="position: absolute; top: 8px; right: 8px"
            @click="dialogWorkTimeReprocess = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="d-flex pb-2">
          <div class="mr-4">
            <div style="color: #555; font-size: 12px; margin-left: 5px">
              วันที่เริ่มต้น
            </div>
            <date-picker
              v-model="dateStartReprocess"
              :class="{ 'date-picker-required': isDateStartInvalidOnReprocess }"
              type="date"
              format="DD/MM/YYYY"
              :clearable="true"
              :disabled-date="disabledAfterDateEndReprocess"
            ></date-picker>
          </div>
          <div>
            <div style="color: #555; font-size: 12px; margin-left: 5px">
              วันที่สิ้นสุด (เลือกได้สูงสุด 1 ปี)
            </div>
            <date-picker
              v-model="dateEndReprocess"
              :class="{ 'date-picker-required': isDateEndInvalidOnReprocess }"
              type="date"
              format="DD/MM/YYYY"
              :clearable="true"
              :disabled-date="disabledBeforeDateStartReprocess"
            ></date-picker>
          </div>
        </v-card-text>
        <v-card-text class="pb-2">
          <v-checkbox
            v-model="isReprocessCalculateAll"
            class="mt-0"
            label="คำนวนทั้งหมด"
            dense
            hide-details
          >
            <template v-slot:label>
              <span class="body-2">คำนวณทั้งหมด</span>
            </template>
          </v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="primary" @click="handleWorkTimeReprocess">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogInfoReport" max-width="480">
      <v-card>
        <v-card-title class="text-h5">
          จำนวนข้อมูลออกรายงานเกินจำนวนที่จำกัดไว้
        </v-card-title>
        <v-card-text>
          จำนวนข้อมูลที่ต้องการออกรายงานมีจำนวน {{ totalReportPdf }} รายการ
          ซึ่งเกินจำนวนสูงสุดที่ระบบกำหนดไว้ที่ {{ maxReportLimit }} รายการ
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined @click="dialogInfoReport = false">ปิด</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import moment from 'moment'
import { mapActions } from 'vuex'

import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import _ from 'lodash'

import OrganizationTreeItem from '@/components/OrganizationTreeItem.vue'

export default {
  components: {
    RecycleScroller,
    DatePicker,
    OrganizationTreeItem,
  },
  data() {
    return {
      reportLanguage: 'th',
      dialogWorkTimeReprocess: false,
      filterReportType: null,
      filterStatusWork: null,
      filterIsActive: true,
      isTransactionMobile: false,
      isSearchSubmitted: false,
      isReprocessSubmitted: false,
      isReprocessCalculateAll: true,
      dateStart: new Date(),
      dateEnd: new Date(),
      dateStartReprocess: moment().startOf('month').toDate(),
      dateEndReprocess: new Date(),
      searchOrganization: '',
      loadingOrganization: false,
      searchEmployee: '',
      searchHardware: '',
      statusSelectedAllOrganization: false,
      selectedOrganizations: [],
      organizations: [],
      employees: [],
      hardwares: [],
      dialogHardware: false,
      dialogOrganization: false,
      dialogEmployee: false,
      dialogProgress: false,
      progressValue: 0,
      interval: null,
      timeout: null,
      sortBy: ['employee_code'],
      sortDesc: [false],
      loading: false,
      options: {},
      totalReport: 0,
      reports: [],
      dialogInfoReport: false,
      totalReportPdf: 0,
      maxReportLimit: 100000,
    }
  },
  filters: {
    dateFormat: function (date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    employeesSelected() {
      return this.employees.filter((employee) => employee.checked)
    },
    statusSelectedAllEmployee() {
      if (_.every(this.employees, ['checked', true])) {
        return 'all'
      } else if (_.some(this.employees, ['checked', true])) {
        return 'indeterminate'
      } else {
        return 'blank'
      }
    },
    hardwaresSelected() {
      return this.hardwares.filter((hardware) => hardware.checked)
    },
    statusSelectedAllHardware() {
      if (_.every(this.hardwares, ['checked', true])) {
        return 'all'
      } else if (_.some(this.hardwares, ['checked', true])) {
        return 'indeterminate'
      } else {
        return 'blank'
      }
    },
    filterEmployees() {
      let items = this.employees

      if (this.searchEmployee) {
        items = items.filter((item) => {
          return (
            item.employee_code
              .toLowerCase()
              .includes(this.searchEmployee.toLowerCase()) ||
            item.firstname_th
              .toLowerCase()
              .includes(this.searchEmployee.toLowerCase()) ||
            item.lastname_th
              .toLowerCase()
              .includes(this.searchEmployee.toLowerCase())
          )
        })
      }

      return items
    },
    filterHardwares() {
      let items = this.hardwares

      if (this.searchHardware) {
        items = items.filter((item) => {
          return (
            item.hardware_code
              .toLowerCase()
              .includes(this.searchHardware.toLowerCase()) ||
            item.title_th
              .toLowerCase()
              .includes(this.searchHardware.toLowerCase())
          )
        })
      }

      return items
    },
    headers() {
      return [
        {
          text: this.reportLanguage === 'th' ? 'รหัสพนักงาน' : 'Employee Code',
          align: 'start',
          value: 'employee_code',
          class: 'text-no-wrap',
        },
        {
          text: this.reportLanguage === 'th' ? 'ชื่อ - สกุล' : 'Employee Name',
          value: 'employee',
          class: 'text-no-wrap',
        },
        {
          text: this.reportLanguage === 'th' ? 'วัน' : 'Day',
          sortable: false,
          align: 'center',
          value:
            this.reportLanguage === 'th'
              ? 'date_title_short_th'
              : 'date_title_short_en',
          class: 'text-no-wrap',
        },
        {
          text: this.reportLanguage === 'th' ? 'วันที่' : 'Date',
          sortable: false,
          align: 'center',
          value: 'transaction_date',
          class: 'text-no-wrap',
        },
        {
          text: this.reportLanguage === 'th' ? 'กะทำงาน' : 'Shift',
          sortable: false,
          align: 'center',
          value: 'shift',
          class: 'text-no-wrap',
        },
        {
          text: this.reportLanguage === 'th' ? 'เวลาเข้า' : 'Time In',
          sortable: false,
          align: 'center',
          value: 'time_in',
          class: 'text-no-wrap',
        },
        {
          text: this.reportLanguage === 'th' ? 'เข้าสาย' : 'Late',
          sortable: false,
          align: 'center',
          value: 'late',
          class: 'text-no-wrap',
        },
        {
          text: this.reportLanguage === 'th' ? 'หมายเลขเครื่อง' : 'Device-In',
          sortable: false,
          align: 'start',
          value: 'hardware_in',
          class: 'text-no-wrap',
        },
        {
          text: this.reportLanguage === 'th' ? 'เวลาออก' : 'Time Out',
          sortable: false,
          align: 'center',
          value: 'time_out',
          class: 'text-no-wrap',
        },
        {
          text: this.reportLanguage === 'th' ? 'ออกก่อน' : 'Early',
          sortable: false,
          align: 'center',
          value: 'early',
          class: 'text-no-wrap',
        },
        {
          text: this.reportLanguage === 'th' ? 'หมายเลขเครื่อง' : 'Device-Out',
          sortable: false,
          align: 'start',
          value: 'hardware_out',
          class: 'text-no-wrap',
        },
        {
          text: this.reportLanguage === 'th' ? 'ประเภทวัน' : 'Day Type',
          sortable: false,
          align: 'start',
          value: 'holiday_type',
          class: 'text-no-wrap',
        },
        {
          text: this.reportLanguage === 'th' ? 'หมายเหตุ' : 'Remark',
          sortable: false,
          align: 'start',
          value: 'remark',
          class: 'text-no-wrap',
        },
      ]
    },
    groupedReports() {
      return this.reports.map((item, i, arr) => ({
        ...item,
        showEmployeeCode:
          i === 0 || arr[i - 1].employee_code !== item.employee_code,
        showEmployeeName:
          i === 0 || arr[i - 1].employee_code !== item.employee_code,
      }))
    },
    isDateStartInvalidOnSearch() {
      return this.isSearchSubmitted && !this.dateStart
    },
    isDateEndInvalidOnSearch() {
      return this.isSearchSubmitted && !this.dateEnd
    },
    isEmployeeInvalidOnSearch() {
      return this.isSearchSubmitted && this.employeesSelected.length === 0
    },
    isDateStartInvalidOnReprocess() {
      return this.isReprocessSubmitted && !this.dateStartReprocess
    },
    isDateEndInvalidOnReprocess() {
      return this.isReprocessSubmitted && !this.dateEndReprocess
    },
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: '[107] บันทึกเวลา - มาสาย/กลับก่อน',
        disabled: true,
      },
    ])

    this.$store.commit('SET_LOADING', true)

    const { company_uuid } = this.$store.state.authentication.company

    try {
      const [organizations, employees, hardwares] = await Promise.all([
        this.fetchOrganizationsAuthorizedTree({
          company_uuid,
          params: {
            dpc: 'report-107-to-list-organization-tree',
            field: 'organization_uuid,title_th', // TODO: not working filter field
          },
        }),
        this.fetchEmployeesAuthorized({
          company_uuid,
          params: {
            dpc: 'report-107-to-list-employee',
            is_active: this.filterIsActive, // TODO: filer active fetchEmployeesAuthorized
            preset: 'selector',
          },
        }),
        this.fetchHardwares({
          params: {
            dpc: 'report-107-to-list-hardware-no-filter',
            company_uuid,
          },
        }),
      ])

      const map = (arr) => {
        return arr ? arr.map(fix) : null
      }
      const fix = (item) => {
        return {
          ...item,
          checked: false,
          children: map(item.children),
        }
      }
      this.organizations = map(organizations)

      this.employees = employees.map((employee) => {
        return { ...employee, checked: false }
      })

      this.hardwares = hardwares.map((hardware) => {
        return { ...hardware, checked: false }
      })

      this.$store.commit('SET_LOADING', false)
    } catch (error) {
      this.$store.commit('SET_LOADING', false)
    }
  },
  methods: {
    ...mapActions({
      generateFileExcel: 'download/generateFileExcel',
      generateFilePdf: 'download/generateFilePdf',
      generateFileProgress: 'download/generateFileProgress',
      fetchReports107: 'report/fetchReports107',
      fetchOrganizationsAuthorizedTree:
        'organization/fetchOrganizationsAuthorizedTree',
      fetchEmployeesAuthorized: 'employee/fetchEmployeesAuthorized',
      fetchHardwares: 'hardware/fetchHardwares',
      workTimeReprocess: 'report/workTimeReprocess',
    }),
    async handleFilterIsActive() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        const employees = await this.fetchEmployeesAuthorized({
          company_uuid,
          params: {
            dpc: 'report-107-to-list-employee',
            is_active: this.filterIsActive, // TODO: filer active fetchEmployeesAuthorized
            preset: 'selector',
          },
        })

        this.handleSelectedAllEmployee(false)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    toggleAllItems(itemsKey, checked) {
      this[itemsKey] = this[itemsKey].map((item) => ({
        ...item,
        checked,
      }))
    },
    handleSelectedAllEmployee(checked) {
      this.toggleAllItems('employees', checked)
      this.handleSelectedAllOrganization(checked)
    },
    handleSelectedAllHardware(checked) {
      this.isTransactionMobile = checked
      this.toggleAllItems('hardwares', checked)
    },
    buildReportPayload(options = {}) {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      const { includeLimit = false } = options

      let order_by = ''
      const sortByKey = sortBy[0] || ''

      if (sortByKey === 'employee_code') order_by = 'employee_code'
      if (sortByKey === 'employee') {
        order_by =
          this.reportLanguage === 'th'
            ? 'employee_firstname_th'
            : 'employee_firstname_en'
      }

      if (sortDesc.length > 0) {
        order_by += sortDesc[0] ? ',desc' : ',asc'
      }

      return {
        company_uuid: this.$store.state.authentication.company.company_uuid,
        body: {
          start_datetime: this.dateStart
            ? moment(this.dateStart).format('YYYY-MM-DD')
            : null,
          end_datetime: this.dateEnd
            ? moment(this.dateEnd).format('YYYY-MM-DD')
            : null,
          order_by: order_by || null,
          limit: includeLimit
            ? `${itemsPerPage},${(page - 1) * itemsPerPage}`
            : null,
          employee_uuids: this.employeesSelected.map((e) => e.employee_uuid),
          hardware_uuids: this.hardwaresSelected.map((e) => e.hardware_uuid),
          is_transaction_mobile: this.isTransactionMobile || undefined,
          page_break_by: this.filterReportType,
          is_locale_en: this.reportLanguage === 'en' ? true : false,
        },
      }
    },
    disabledAfterDateEnd(date) {
      if (moment(date).isAfter(moment(), 'day')) return true
      if (!this.dateEnd) return false
      const maxStart = moment(this.dateEnd).subtract(1, 'month').toDate()
      return date > new Date(this.dateEnd) || date < maxStart
    },
    disabledBeforeDateStart(date) {
      if (moment(date).isAfter(moment(), 'day')) return true
      if (!this.dateStart) return false
      const maxEnd = moment(this.dateStart).add(1, 'month').toDate()
      return date < new Date(this.dateStart) || date > maxEnd
    },
    disabledAfterDateEndReprocess(date) {
      if (moment(date).isAfter(moment(), 'day')) return true
      if (!this.dateEndReprocess) return false
      const maxStart = moment(this.dateEndReprocess)
        .subtract(1, 'year')
        .toDate()
      return date > new Date(this.dateEndReprocess) || date < maxStart
    },
    disabledBeforeDateStartReprocess(date) {
      if (moment(date).isAfter(moment(), 'day')) return true
      if (!this.dateStartReprocess) return false
      const maxEnd = moment(this.dateStartReprocess).add(1, 'year').toDate()
      return date < new Date(this.dateStartReprocess) || date > maxEnd
    },
    handleGetDataFromApi() {
      this.isSearchSubmitted = true
      if (!this.dateStart || !this.dateEnd) return

      this.getDataFromApi()
    },
    handleSearchOrganization() {
      this.loadingOrganization = true
      this.getOrganizationsFilterBySearch()
    },
    getOrganizationsFilterBySearch: _.debounce(async function () {
      const organizations = await this.getOrganizationsAuthorizedTree()

      const map = (arr) => {
        return arr ? arr.map(fix) : null
      }
      const fix = (item) => {
        return {
          ...item,
          checked: this.selectedOrganizations.some(
            (org) => org.organization_uuid === item.organization_uuid
          ),
          children: map(item.children),
        }
      }
      this.organizations = map(organizations)
    }, 500),
    async getOrganizationsAuthorizedTree() {
      try {
        const { company_uuid } = this.$store.state.authentication.company
        const payload = {
          company_uuid,
          params: {
            dpc: 'report-107-to-list-organization-tree',
            search: this.searchOrganization || '',
          },
        }
        const organizations = await this.fetchOrganizationsAuthorizedTree(
          payload
        )
        return organizations
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loadingOrganization = false
      }
    },
    handleSelectedAllOrganization(checked) {
      this.statusSelectedAllOrganization = checked

      this.organizations.forEach((organization) => {
        const result = this.setCheckAllOrganizationRecursive(organization)
        this.handleSelectedOrganization(result)
      })
    },
    setCheckAllOrganizationRecursive(organization) {
      organization.checked = this.statusSelectedAllOrganization

      if (organization.children && organization.children.length) {
        organization.children.forEach((children) => {
          this.setCheckAllOrganizationRecursive(children)
        })
      }
      return organization
    },
    handleSelectedOrganization(organization) {
      this.setCheckOrganizationRecursive(organization)

      this.employees = this.employees.map((employee) => {
        if (
          this.selectedOrganizations.some(
            (org) =>
              org.organization_uuid === employee.organization.organization_uuid
          )
        ) {
          return { ...employee, checked: true }
        }
        return { ...employee, checked: false }
      })
    },
    setCheckOrganizationRecursive(organization, depth = 0, maxDepth = 50) {
      if (depth > maxDepth) {
        console.warn('Max recursion depth reached')
        return
      }

      if (organization.checked) {
        const index = this.selectedOrganizations.findIndex(
          (org) => org.organization_uuid === organization.organization_uuid
        )
        if (index === -1) {
          this.selectedOrganizations = [
            ...this.selectedOrganizations,
            organization,
          ]
        }
      } else {
        this.selectedOrganizations = this.selectedOrganizations.filter(
          (org) => org.organization_uuid !== organization.organization_uuid
        )
      }

      if (organization.children && organization.children.length) {
        organization.children.forEach((children) => {
          this.setCheckOrganizationRecursive(children, depth + 1, maxDepth)
        })
      }
    },
    handleSelectedEmployee(checked, employee) {
      const { employee_uuid } = employee

      this.employees = this.employees.map((employee) => {
        if (employee.employee_uuid === employee_uuid) {
          return { ...employee, checked }
        }
        return employee
      })
    },
    handleSelectedHardware(checked, hardware) {
      const { hardware_uuid } = hardware

      this.hardwares = this.hardwares.map((hardware) => {
        if (hardware.hardware_uuid === hardware_uuid) {
          return { ...hardware, checked }
        }
        return hardware
      })
    },
    handleDialogOrganization() {
      this.dialogOrganization = false
      this.searchOrganization = ''

      this.options.page = 1
    },
    handleDialogEmployee() {
      this.dialogEmployee = false
      this.searchEmployee = ''

      this.options.page = 1
    },
    handleDialogHardware() {
      this.dialogHardware = false
      this.searchHardware = ''

      this.options.page = 1
    },
    downloadProgress(job_process_uuid, ping_after_ms, downloadType) {
      this.interval = setInterval(() => {
        this.generateFileProgress(job_process_uuid)
          .then((res) => {
            if (res.total === 0) {
              this.progressValue = 100
              this.timeout = setTimeout(() => {
                this.dialogProgress = false
              }, 200)

              clearInterval(this.interval)

              const snackbar = {
                show: true,
                color: 'warning',
                timeout: 4000,
                message: 'ไม่มีข้อมูล',
              }

              this.$store.commit('SET_SNACKBAR', snackbar)
              return
            }

            if (res.is_success) {
              this.progressValue = 100
              this.timeout = setTimeout(() => {
                clearInterval(this.interval)
                this.dialogProgress = false

                if (downloadType !== 'workTimeReprocess') {
                  const fileUrl = res.resource_uri
                  const fileName = fileUrl.split('/').pop()

                  const a = document.createElement('a')
                  a.setAttribute('hidden', '')
                  a.setAttribute('href', fileUrl)
                  a.setAttribute('target', '_blank')
                  a.setAttribute('download', fileName)
                  document.body.appendChild(a)
                  a.click()
                  document.body.removeChild(a)
                }
              }, 200)
            } else {
              this.progressValue = (100 / res.total) * res.progress
              // if (this.progressValue < 60) {
              //   this.progressValue += 10
              // } else if (this.progressValue < 80) {
              //   this.progressValue += 5
              // } else if (this.progressValue < 95) {
              //   this.progressValue += 1
              // } else {
              //   this.progressValue = 95
              // }
            }
          })
          .catch((error) => {
            clearInterval(this.interval)
            this.dialogProgress = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }, ping_after_ms)
    },
    handleDownloadFileExcel() {
      const payload = {
        ...this.buildReportPayload(),
        reportType: 'report-107',
        params: {
          dpc: 'report-107-excel-to-list-report-107-excel',
        },
      }

      this.generateFileExcel(payload)
        .then((res) => {
          if (res.total === 0) {
            const snackbar = {
              show: true,
              color: 'warning',
              timeout: 4000,
              message: 'ไม่มีข้อมูล',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)
            return
          }

          this.progressValue = 0
          this.dialogProgress = true

          this.downloadProgress(res.job_process_uuid, res.ping_after_ms)
        })
        .catch((error) => {
          this.dialogProgress = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    async handleDownloadFilePdf() {
      this.isSearchSubmitted = true
      if (
        !this.dateStart ||
        !this.dateEnd ||
        this.employeesSelected.length === 0
      )
        return

      try {
        const payload = {
          ...this.buildReportPayload(),
          reportType: 'report-107',
          params: {
            dpc: 'report-107-pdf-to-list-report-107-pdf',
          },
        }

        const { company_uuid } = this.$store.state.authentication.company

        const { total } = await this.fetchReports107({
          company_uuid,
          body: {
            start_datetime: this.dateStart
              ? moment(this.dateStart).format('YYYY-MM-DD')
              : null,
            end_datetime: this.dateEnd
              ? moment(this.dateEnd).format('YYYY-MM-DD')
              : null,
            limit: '1,0',
            order_by: 'employee_code,asc',
            employee_uuids: this.employeesSelected.length
              ? this.employeesSelected.map((e) => e.employee_uuid)
              : [],
            hardware_uuids: this.hardwaresSelected.length
              ? this.hardwaresSelected.map((e) => e.hardware_uuid)
              : [],
            is_transaction_mobile: this.isTransactionMobile ? true : undefined,
            is_normal:
              this.filterStatusWork === 'normal'
                ? true
                : this.filterStatusWork === 'is_late_and_early'
                ? false
                : null,
            is_late: this.filterStatusWork === 'is_late' ? true : null,
            is_early: this.filterStatusWork === 'is_early' ? true : null,
          },
          params: {
            dpc: 'report-107-to-list-report-107',
          },
        })

        if (total > this.maxReportLimit) {
          this.totalReportPdf = total
          this.dialogInfoReport = true
          return
        }

        const res = await this.generateFilePdf(payload)

        if (res.total === 0) {
          const snackbar = {
            show: true,
            color: 'warning',
            timeout: 4000,
            message: 'ไม่มีข้อมูล',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)
          return
        }

        this.progressValue = 0
        this.dialogProgress = true

        this.downloadProgress(res.job_process_uuid, res.ping_after_ms)
      } catch (error) {
        this.dialogProgress = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async getDataFromApi() {
      try {
        if (this.employeesSelected.length === 0) return

        this.loading = true
        const { sortBy, sortDesc, page, itemsPerPage } = this.options

        let order_by = ''
        const sortByKey = sortBy[0] || ''

        if (sortByKey === 'employee_code') order_by = 'employee_code'
        if (sortByKey === 'employee') {
          order_by =
            this.reportLanguage === 'th'
              ? 'employee_firstname_th'
              : 'employee_firstname_en'
        }

        if (sortDesc.length > 0) {
          if (sortDesc[0]) {
            order_by += `,desc`
          } else {
            order_by += `,asc`
          }
        }

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          body: {
            start_datetime: this.dateStart
              ? moment(this.dateStart).format('YYYY-MM-DD')
              : null,
            end_datetime: this.dateEnd
              ? moment(this.dateEnd).format('YYYY-MM-DD')
              : null,
            limit: `${itemsPerPage},${(page - 1) * itemsPerPage}`,
            order_by: order_by ? order_by : null,
            employee_uuids: this.employeesSelected.length
              ? this.employeesSelected.map((e) => e.employee_uuid)
              : [],
            hardware_uuids: this.hardwaresSelected.length
              ? this.hardwaresSelected.map((e) => e.hardware_uuid)
              : [],
            is_transaction_mobile: this.isTransactionMobile ? true : undefined,
            is_normal:
              this.filterStatusWork === 'normal'
                ? true
                : this.filterStatusWork === 'is_late_and_early'
                ? false
                : null,
            is_late: this.filterStatusWork === 'is_late' ? true : null,
            is_early: this.filterStatusWork === 'is_early' ? true : null,
          },
          params: {
            dpc: 'report-107-to-list-report-107',
          },
        }

        const { total, data } = await this.fetchReports107(payload)
        this.totalReport = total
        this.reports = data
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loading = false
      }
    },
    async handleWorkTimeReprocess() {
      this.isReprocessSubmitted = true
      if (!this.dateStartReprocess || !this.dateEndReprocess) return

      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          body: {
            start_datetime: this.dateStartReprocess
              ? moment(this.dateStartReprocess).format('YYYY-MM-DD HH:mm:ss')
              : null,
            end_datetime: this.dateEndReprocess
              ? moment(this.dateEndReprocess).format('YYYY-MM-DD HH:mm:ss')
              : null,
          },
          params: {
            all: this.isReprocessCalculateAll ? 'true' : 'false',
          },
        }

        const { data } = await this.workTimeReprocess(payload)

        this.dialogWorkTimeReprocess = false

        this.progressValue = 0
        this.dialogProgress = true

        this.downloadProgress(
          data.job_process_uuid,
          data.ping_after_ms,
          'workTimeReprocess'
        )
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
    clearInterval(this.interval)
  },
}
</script>

<style scoped>
.date-picker-required ::v-deep .mx-input {
  border-color: #f44336;
}

.date-picker-required ::v-deep .mx-input:hover,
.date-picker-required ::v-deep .mx-input:focus {
  border-color: #f44336;
}

.required-border {
  border-color: #f44336 !important;
}
</style>
